import { API } from './api';
import { GW_SERVICES_PREFIXES } from '../constants/gateway';

const { FILES } = GW_SERVICES_PREFIXES;

/** Общий эндпоинт для добавления файла в базу.
 * formData должна иметь 2 ключа: file, importance.
 * importance по умолчанию 'low'. */
export const SaveFileToFilesMS = (shared_id: string, data: FormData) =>
  API.putFiles(`${FILES}/files/${shared_id}/`, data);

/** Эндпоинт для получения файла с микросервиса файлов. */
export const GetFileFromFilesMS = (shared_id: string) =>
  API.get(`${FILES}/files/${shared_id}/`, undefined, { unparsed: true });
